import { useQuery } from 'react-query';
import { useLocation, useParams } from 'react-router-dom';

// Our Axios Instance
import axiosInstance from 'services/API/API';

// Api URLS
import { getUserLiabilitiesUrl } from 'shared/api-urls';

// QUery keys
import { USER_STUDENTS } from 'shared/query-keys';

// our routes
import { LIABILITY_ADDITIONAL_ROUTE } from 'routes';

// Our utils
import getNonNullValues from 'shared/utils/clientOnboarding/getNonNullValues';

function useGetUserStudentLiability() {
	const location = useLocation();
	const { pathname } = location;
	const { tradeLineId } = useParams();

	const isManualRoute = pathname.includes(LIABILITY_ADDITIONAL_ROUTE);

	// if this is a isManualRoute do not do the data binding

	const urlWithTradeLineId = `${getUserLiabilitiesUrl}${tradeLineId}`;

	return useQuery(
		[USER_STUDENTS, tradeLineId],
		async () => {
			const response = await axiosInstance.get(urlWithTradeLineId);

			// This is the data from Sora Api which includes meta
			const Liability = response.data;

			// This is the actual mortgage Data
			const studentLiabilityData = Liability.data;
			return studentLiabilityData;
		},
		{
			enabled: !isManualRoute,
			refetchOnWindowFocus: false,
			select: ({
				expectedPayOffDate,
				dataSource,
				financialGoal,
				interestRate,
				lender,
				lenderType,
				loanType,
				monthlyPay,
				mfiDataSource,
				outstandingBalance,
				rateManuallyUpdated,
				tenureMonth,
				studentInfo,
				subType
			}) => {
				// get rid of garbage data before giving it to AutoLiability Component
				const studentDataWithoutNullValues = getNonNullValues({
					expectedPayOffDate,
					dataSource,
					financialGoal,
					interestRate,
					lender,
					lenderType,
					loanType,
					monthlyPay,
					mfiDataSource,
					outstandingBalance,
					rateManuallyUpdated,
					tenureMonth,
					studentInfo,
					subType
				});
				return studentDataWithoutNullValues;
			}
		}
	);
}

export default useGetUserStudentLiability;
